import React from "react";
import { useSelector } from "react-redux";
import "./ScoreUpdateDisplay.css";

const ScoreUpdateDisplay = () => {
  const currentScore = useSelector((state) => state.game.score);
  const isGameStarted = useSelector((state) => state.game.isGameStarted);
  
  return (
    <div data-testid="score-update-component">
      {isGameStarted && <p className="score-font">Score: {currentScore}</p>}
    </div>
  );
};

export default ScoreUpdateDisplay;